import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dea68fea"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dea68fea')) {
      api.createRecord('dea68fea', component.options)
    } else {
      api.reload('dea68fea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dea68fea", function () {
      api.rerender('dea68fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/forecast/index.vue"
export default component.exports